[
  {
    "category": "display",
    "name": "Abril Fatface",
    "sane": "abril_fatface",
    "variants": [
      "0,400"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "Alegreya",
    "sane": "alegreya",
    "variants": [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Alegreya Sans",
    "sane": "alegreya_sans",
    "variants": [
      "0,100",
      "1,100",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Archivo Narrow",
    "sane": "archivo_narrow",
    "variants": [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "monospace",
    "name": "Azeret Mono",
    "sane": "azeret_mono",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "handwriting",
    "name": "Bad Script",
    "sane": "bad_script",
    "variants": [
      "0,400"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "BioRhyme",
    "sane": "biorhyme",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "Bitter",
    "sane": "bitter",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Cardo",
    "sane": "cardo",
    "variants": [
      "0,400",
      "1,400",
      "0,700"
    ],
    "subsets": [
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Chivo",
    "sane": "chivo",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "handwriting",
    "name": "Comic Neue",
    "sane": "comic_neue",
    "variants": [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    "subsets": [
      "latin"
    ]
  },
  {
    "category": "serif",
    "name": "Cormorant",
    "sane": "cormorant",
    "variants": [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "handwriting",
    "name": "Dancing Script",
    "sane": "dancing_script",
    "variants": [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "DM Sans",
    "sane": "dm_sans",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "DM Serif Display",
    "sane": "dm_serif_display",
    "variants": [
      "0,400",
      "1,400"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "DM Serif Text",
    "sane": "dm_serif_text",
    "variants": [
      "0,400",
      "1,400"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "Eczar",
    "sane": "eczar",
    "variants": [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    "subsets": [
      "devanagari",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Familjen Grotesk",
    "sane": "familjen_grotesk",
    "variants": [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Fira Sans",
    "sane": "fira_sans",
    "variants": [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Fraunces",
    "sane": "fraunces",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "IBM Plex Sans",
    "sane": "ibm_plex_sans",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "monospace",
    "name": "Inconsolata",
    "sane": "inconsolata",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Inknut Antiqua",
    "sane": "inknut_antiqua",
    "variants": [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    "subsets": [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Inter",
    "sane": "inter",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Josefin Sans",
    "sane": "josefin_sans",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Josefin Slab",
    "sane": "josefin_slab",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    "subsets": [
      "latin"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Karla",
    "sane": "karla",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Lato",
    "sane": "lato",
    "variants": [
      "0,100",
      "1,100",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700",
      "0,900",
      "1,900"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "Libre Baskerville",
    "sane": "libre_baskerville",
    "variants": [
      "0,400",
      "1,400",
      "0,700"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Libre Franklin",
    "sane": "libre_franklin",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Literata",
    "sane": "literata",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Lora",
    "sane": "lora",
    "variants": [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Manrope",
    "sane": "manrope",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Merriweather",
    "sane": "merriweather",
    "variants": [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700",
      "0,900",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Montserrat",
    "sane": "montserrat",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Mukta",
    "sane": "mukta",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    "subsets": [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "Neuton",
    "sane": "neuton",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "1,400",
      "0,700",
      "0,800"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "display",
    "name": "New Rocker",
    "sane": "new_rocker",
    "variants": [
      "0,400"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "Newsreader",
    "sane": "newsreader",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Noto Sans JP",
    "sane": "noto_sans_jp",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    "subsets": [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Nunito",
    "sane": "nunito",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Nunito Sans",
    "sane": "nunito_sans",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Old Standard TT",
    "sane": "old_standard_tt",
    "variants": [
      "0,400",
      "1,400",
      "0,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Open Sans",
    "sane": "open_sans",
    "variants": [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Oswald",
    "sane": "oswald",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Outfit",
    "sane": "outfit",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Overpass",
    "sane": "overpass",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Playfair Display",
    "sane": "playfair_display",
    "variants": [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Plus Jakarta Sans",
    "sane": "plus_jakarta_sans",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    "subsets": [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Poppins",
    "sane": "poppins",
    "variants": [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Proza Libre",
    "sane": "proza_libre",
    "variants": [
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "PT Sans",
    "sane": "pt_sans",
    "variants": [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "PT Serif",
    "sane": "pt_serif",
    "variants": [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Rajdhani",
    "sane": "rajdhani",
    "variants": [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    "subsets": [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Raleway",
    "sane": "raleway",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Roboto",
    "sane": "roboto",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Roboto Condensed",
    "sane": "roboto_condensed",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "monospace",
    "name": "Roboto Mono",
    "sane": "roboto_mono",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Roboto Serif",
    "sane": "roboto_serif",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Roboto Slab",
    "sane": "roboto_slab",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Rubik",
    "sane": "rubik",
    "variants": [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "arabic",
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "handwriting",
    "name": "Sacramento",
    "sane": "sacramento",
    "variants": [
      "0,400"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Source Sans 3",
    "sane": "source_sans_3",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Source Serif 4",
    "sane": "source_serif_4",
    "variants": [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Space Grotesk",
    "sane": "space_grotesk",
    "variants": [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "monospace",
    "name": "Space Mono",
    "sane": "space_mono",
    "variants": [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Spectral",
    "sane": "spectral",
    "variants": [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Syne",
    "sane": "syne",
    "variants": [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    "subsets": [
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "handwriting",
    "name": "Tangerine",
    "sane": "tangerine",
    "variants": [
      "0,400",
      "0,700"
    ],
    "subsets": [
      "latin"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Ubuntu",
    "sane": "ubuntu",
    "variants": [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,700",
      "1,700"
    ],
    "subsets": [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "serif",
    "name": "Ultra",
    "sane": "ultra",
    "variants": [
      "0,400"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  },
  {
    "category": "display",
    "name": "UnifrakturMaguntia",
    "sane": "unifrakturmaguntia",
    "variants": [
      "0,400"
    ],
    "subsets": [
      "latin"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Varela Round",
    "sane": "varela_round",
    "variants": [
      "0,400"
    ],
    "subsets": [
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "sans-serif",
    "name": "Work Sans",
    "sane": "work_sans",
    "variants": [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    "subsets": [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    "category": "serif",
    "name": "Zilla Slab",
    "sane": "zilla_slab",
    "variants": [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    "subsets": [
      "latin",
      "latin-ext"
    ]
  }
]